export default __webpack_public_path__ + "static/media/38.0149f39e.png";